import { render, staticRenderFns } from "./ButtonTarget.vue?vue&type=template&id=4ca7b902&scoped=true&"
import script from "./ButtonTarget.vue?vue&type=script&lang=js&"
export * from "./ButtonTarget.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTarget.vue?vue&type=style&index=0&id=4ca7b902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7b902",
  null
  
)

export default component.exports